import React from "react";
import "./immediateSessionDot.css";

const DONATED_SESSION_TYPE = "5";

const LABELS = {
  immediate_ondemand: "Donated session booked via Find a Medium Now",
  immediate_backfill: "Donated session booked via Find a Medium Now (backfill medium)",
};

/**
 * Green dot shown in front of the copy icon / Session # in every admin
 * Appointments tab when the appointment was booked from "Find a Medium Now"
 * (booking_source set by ImmediateOnDemandMatcher). Normal bookings show nothing.
 *
 * Rendered as an inline SVG (not a styled <span>) so global span/flex styles in
 * the tables can't stretch it.
 */
export default function ImmediateSessionDot({ appointment }) {
  const source = appointment && appointment.booking_source;
  // Donated sessions only (session_type = 5).
  const isDonated = appointment && String(appointment.session_type) === DONATED_SESSION_TYPE;
  if (!isDonated || !source || !LABELS[source]) return null;

  return (
    <svg
      className="immediate-session-dot"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      role="img"
      aria-label={LABELS[source]}
    >
      <title>{LABELS[source]}</title>
      <circle cx="5" cy="5" r="5" fill="#22a75a" />
    </svg>
  );
}
